import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space['space-300']} ${space['space-400']} ${space['space-600']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};

  [data-testid='basket-contents'] > *:first-child {
    padding-right: ${space['space-1200']};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-1200']};

    [data-testid='basket-contents'] > *:first-child {
      padding-right: 0;
    }
  }
`;

export const ActionBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  padding: ${space['space-400']};
  background: ${semantic.bg.canvas};
  border-top: 1px solid ${semantic.border.subtle};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-1200']};
  }
`;

export const ActionRow = styled.div`
  display: flex;
  gap: ${space['space-300']};
`;

export const ContinueButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-100']};
  width: 100%;
  height: 40px;
  padding: ${space['space-100']} ${space['space-400']};
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};
`;
